import { path } from 'ramda'
import { createSelector } from 'reselect'
import { StateInterface } from '../types/states'

const selectFormDomain = (state: StateInterface) => state.form

const selectFormValues = (formName: string) =>
  createSelector(selectFormDomain, (form) =>
    path([formName, 'values'], form)
  ) as any | undefined

export { selectFormDomain, selectFormValues }
